import BaseService from './BaseService'
import { httpClient } from '@/api/httpClient'
import UrlService from './UrlService'

export default class ChatMessageTemplateService extends BaseService {
  static async create (data) {
    return httpClient.post('/protected/settings/templates', data)
  }

  static async update (id, data) {
    return httpClient.put(`/protected/settings/templates/${id}`, data)
  }

  static async delete (id) {
    return httpClient.delete(`/protected/settings/templates/${id}`)
  }

  static async getChatMessageTemplates (payload, payloadQ) {
    const filters = new URLSearchParams()
    filters.set('page', payload.page)
    filters.set('per_page', payload.per_page)

    const q = UrlService.getFiltersQuery(payloadQ)

    const data = await httpClient.get(`/protected/settings/templates?${filters}&${q}`)

    return data
  }
}
